<template>
  <div class="card-scheme-logos" aria-label="Visa, Mastercard, American Express">
    <svg class="card-scheme-logo" viewBox="0 0 48 32" role="img" aria-label="Visa">
      <rect width="48" height="32" rx="4" fill="#1A1F71"/>
      <text x="24" y="21" text-anchor="middle" fill="#ffffff" font-family="Arial, Helvetica, sans-serif" font-style="italic" font-weight="700" font-size="14">VISA</text>
    </svg>
    <svg class="card-scheme-logo" viewBox="0 0 48 32" role="img" aria-label="Mastercard">
      <rect width="48" height="32" rx="4" fill="#ffffff" stroke="#E6E6E6"/>
      <circle cx="19" cy="16" r="8" fill="#EB001B"/>
      <circle cx="29" cy="16" r="8" fill="#F79E1B"/>
      <path d="M24 9.4a8 8 0 0 1 0 13.2 8 8 0 0 1 0-13.2z" fill="#FF5F00"/>
    </svg>
    <svg class="card-scheme-logo card-scheme-logo-amex" viewBox="0 0 56 32" role="img" aria-label="American Express">
      <rect width="56" height="32" rx="4" fill="#2E77BC"/>
      <text x="28" y="13" text-anchor="middle" fill="#ffffff" font-family="Arial, Helvetica, sans-serif" font-weight="700" font-size="7">AMERICAN</text>
      <text x="28" y="23" text-anchor="middle" fill="#ffffff" font-family="Arial, Helvetica, sans-serif" font-weight="700" font-size="7">EXPRESS</text>
    </svg>
  </div>
</template>

<script>
    export default {
        name: "CardSchemeLogos"
    }
</script>

<style scoped>
  .card-scheme-logos {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding-top: 8px;
  }
  .card-scheme-logo {
    height: 28px;
    width: 42px;
  }
  .card-scheme-logo-amex {
    width: 49px;
  }
</style>



// WEBPACK FOOTER //
// src/components/CardSchemeLogos.vue